import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import DashboardRoleEditDto from 'app/admin/user/dto/DashboardRoleEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import NamedDto from 'modules/base/dto/NamedDto';
import EnumDto from 'modules/base/dto/enum/EnumDto';

class DashboardRoleEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'dashboardRoleEditControl';
	}

	/**
	 * @return {Promise<DashboardRoleEditDto>>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new DashboardRoleEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<DashboardRoleEditDto>>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new DashboardRoleEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {DashboardRoleEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {DashboardRoleEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<NamedDto[]>>}
	 */
	getContentPermissionListContentTypeSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getContentPermissionListContentTypeSelection`)
				.then(response => resolve(response.data != null ? response.data.map(d => new NamedDto().setup(d)) : []))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<EnumDto[]>>}
	 */
	getServicePermissionListServiceSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getServicePermissionListServiceSelection`)
				.then(response => resolve(response.data != null ? response.data.map(d => new EnumDto().setup(d)) : []))
				.catch(reject);
		});
	}
}

export default new DashboardRoleEditService();
